<template>
    <div class="mb-5">
        <h4 class="mb-3">Settings</h4>

        <el-checkbox v-model="fulfillment.is_autocancel">autocancel - automatically cancel DE and JA campaigns when the fulfillment goal is reached</el-checkbox>

        <div class="mt-2" v-if="! readonly">
            <btn :click="save">Save</btn>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'fulfillment',
            'readonly',
        ],
        methods: {
            save() {
                return axios.post(url(`de/fulfillment/${this.fulfillment.id}/settings`), {
                    is_autocancel: this.fulfillment.is_autocancel
                }).then((response) => {
                    this.$emit('changed');
                });
            },
        },
    }
</script>
